import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Handlewarning from '../entities/handlewarning'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface HandlewarningState extends ListState<Handlewarning>{
    editHandlewarning:Handlewarning
}
class UserMutations extends ListMutations<Handlewarning>{

}
class HandlewarningModule extends ListModule<HandlewarningState,any,Handlewarning>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<Handlewarning>(),
        loading:false,
        editHandlewarning:new Handlewarning()
    }
    actions={
        async getAll(context:ActionContext<HandlewarningState,any>,payload:any){
            //console.log(payload.data);
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/TrapHandlewarning/GetPaged',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<Handlewarning>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },
        async create(context:ActionContext<HandlewarningState,any>,payload:any){
            await Ajax.post('/api/services/app/TrapHandlewarning/Create',payload.data);
        },
        async update(context:ActionContext<HandlewarningState,any>,payload:any){
            await Ajax.put('/api/services/app/TrapHandlewarning/Update',payload.data);
        },
        async delete(context:ActionContext<HandlewarningState,any>,payload:any){
            await Ajax.delete('/api/services/app/TrapHandlewarning/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<HandlewarningState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/TrapHandlewarning/GetById?Id='+payload.id);
            return reponse.data.result as Handlewarning;
        },
        ///获取所有设备数量
        async getAllwarning(context:ActionContext<HandlewarningState,any>){
            let reponse=await Ajax.get('/api/services/app/TrapHandlewarning/getAllwarning');
            return reponse.data.result;
        }
    };
    mutations={
        setCurrentPage(state:HandlewarningState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:HandlewarningState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:HandlewarningState,handlewarning:Handlewarning){
            
            state.editHandlewarning=handlewarning;
            //console.log(state.editFloor);
        }
    }
}
const handlewarningModule=new HandlewarningModule();
export default handlewarningModule;